export const handleEmailChange = (email) => {
    return {
        type: 'LOGIN_FORM_EMAIL',
        payload: email
    }
};

export const handlePasswordChange = (password) => {
    return {
        type: 'LOGIN_FORM_PASSWORD',
        payload: password
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Login/components/CoreContent/components/Form/actions.js